import type { Size } from "web_myplann/Chat/Types/pinchZoom";

export const getNaturalSize = (
	image: HTMLImageElement | null,
): Size | undefined =>
	image?.naturalWidth && image.naturalHeight
		? { width: image.naturalWidth, height: image.naturalHeight }
		: undefined;
